import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb6b520e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-style-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "background-image-wrapper" }
const _hoisted_4 = { class: "background-image" }
const _hoisted_5 = {
  class: "title",
  style: {"margin-top":"10px"}
}
const _hoisted_6 = {
  class: "row",
  style: {"margin-top":"10px","margin-bottom":"0"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "input_div" }
const _hoisted_10 = {
  class: "title",
  style: {"margin-top":"10px"}
}
const _hoisted_11 = {
  class: "row",
  style: {"margin-top":"10px","margin-bottom":"0"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_13 = { class: "btns" }

import { nanoid } from 'nanoid'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore, useMainStore } from '@/store'
import { PPTElement } from '@/types/slides'
import { uploadFile } from '@/api/combo'
import { getPptIdByUrl } from "@/utils/common";
import { useI18n } from 'vue-i18n'
import {
  uploadFileToOSS,
  getFileExtension
} from "@/utils/uploadOss";
import FileInput from '@/components/FileInput.vue'
import { Button, Input, InputNumber, Divider } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoInput',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n()
const slidesStore = useSlidesStore()
const { currentSlide, slides } = storeToRefs(slidesStore)
const { pptId } = storeToRefs(useMainStore())


const companyName = ref('')
const logoSrc = ref('')
const imgLeft = ref(30)
const imgTop = ref(30)
const nameLeft = ref(30)
const nameTop = ref(500)



// const { createImageElement, createTextElement } = useCreateElement()
// const { applyPresetThemeToSingleSlide } = useSlideTheme()

// 设置Logo
const setVideoPoster = async (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  let fileType = getFileExtension(imageFile.name);
  const fileRes: any = await uploadFileToOSS('content', imageFile, 2, fileType)
  logoSrc.value = process.env.VUE_APP_OSS_PUBLIC_BUCKET + fileRes.name
}

// 设置元素位置
const updateLeft = (value: number) => {
  imgLeft.value = value
}
const updateTop = (value: number) => {
  imgTop.value = value
}
const updateNameLeft = (value: number) => {
  nameLeft.value = value
}
const updateNameTop = (value: number) => {
  nameTop.value = value
}

const setElement = () => {
  const img: PPTElement = {
    'type': 'image',
    'id': nanoid(10),
    'src': logoSrc.value,
    'width': 60,
    'height': 60,
    'left': imgLeft.value,
    'top': imgTop.value,
    'fixedRatio': true,
    'rotate': 0
  }
  const name: PPTElement = {
    'id': nanoid(10),
    'type': 'text',
    'content': `<p style="">${companyName.value}</p>`,
    'defaultColor': '#333',
    'defaultFontName': 'Microsoft Yahei',
    'height': 62,
    'width': 300,
    'left': nameLeft.value,
    'top': nameTop.value,
    'rotate': 0,
    'vertical': false
  }
  const list = []
  logoSrc.value && list.push(img)
  companyName.value && list.push(name)
  return list
}

const insertSingle = () => {
  if (!currentSlide.value) return
  const newElList = setElement()
  if (newElList.length === 0) return
  let elementList: PPTElement[] = JSON.parse(JSON.stringify(currentSlide.value.elements))
  elementList = [...elementList, ...newElList]
  slidesStore.updateSlide({ elements: elementList })
  emit('close')
}

const insertAll = () => {
  if (!currentSlide.value) return
  if (!logoSrc.value && !companyName.value) return
  const slideList = slides.value
  let elementList
  for (const slide of slideList) {
    const newElList = setElement()
    elementList = slide.elements
    elementList = [...elementList, ...newElList]
    slide.elements = elementList
  }
  slidesStore.setSlides(slideList)
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.canvasTool.logo.text1`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FileInput, {
        onChange: _cache[0] || (_cache[0] = files => setVideoPoster(files))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "content",
              style: _normalizeStyle({ backgroundImage: `url(${logoSrc.value})` })
            }, [
              _createVNode(_component_IconPlus)
            ], 4)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.canvasTool.logo.position`)), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(InputNumber), {
          prefix: _unref(t)(`public.font.horizontal`) + '：',
          step: 5,
          value: imgLeft.value,
          onChange: _cache[1] || (_cache[1] = value => updateLeft(value as number)),
          style: {"flex":"4"}
        }, null, 8, ["prefix", "value"]),
        _hoisted_7,
        _createVNode(_unref(InputNumber), {
          prefix: _unref(t)(`public.font.vertical`) + '：',
          step: 5,
          value: imgTop.value,
          onChange: _cache[2] || (_cache[2] = value => updateTop(value as number)),
          style: {"flex":"4"}
        }, null, 8, ["prefix", "value"])
      ])
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`editor.canvasTool.logo.text2`)), 1),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(Input), {
        value: companyName.value,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((companyName).value = $event)),
        placeholder: _unref(t)(`editor.canvasTool.logo.companyNamePlaceholder`)
      }, null, 8, ["value", "placeholder"]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(`editor.canvasTool.logo.position`)), 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_unref(InputNumber), {
          prefix: _unref(t)(`public.font.horizontal`) + '：',
          step: 5,
          value: nameLeft.value,
          onChange: _cache[4] || (_cache[4] = value => updateNameLeft(value as number)),
          style: {"flex":"4"}
        }, null, 8, ["prefix", "value"]),
        _hoisted_12,
        _createVNode(_unref(InputNumber), {
          prefix: _unref(t)(`public.font.vertical`) + '：',
          step: 5,
          value: nameTop.value,
          onChange: _cache[5] || (_cache[5] = value => updateNameTop(value as number)),
          style: {"flex":"4"}
        }, null, 8, ["prefix", "value"])
      ])
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_unref(Button), {
        style: {"margin-right":"10px"},
        onClick: insertSingle
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.canvasTool.logo.single`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        type: "primary",
        onClick: insertAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.canvasTool.logo.all`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})